// Load helpers
import importScript from './helpers/import-script';
import initPopular from './helpers/popular-init';
import initSearch from './helpers/search-init';
import initSearchMobile from './helpers/mobile-search-init';
import initSearchMain from './helpers/main-search-init';
import initResultPage from './helpers/result-page';
import initTestResultPage from './helpers/result-test-page';
import initDeflection from './helpers/deflection-init';

// Check if conf file exists
if (typeof window.inbAppSdk === 'undefined') {
  throw new ReferenceError("Inbenta SDK couldn't be started, please contact with support for more information.");
}

// Retrieve configuration data
const app = window.inbAppSdk;
let secret = false;

// SDK configuration changes depending on the current domain.
// Defined in ./credentials.js
let domain = window.location.host || window.location.hostname;
const pathname = window.location.pathname;
if(pathname.indexOf('page-de-recherche-test') > -1){
  domain = domain + '-test';
}
const sdkConfig = window.InbentaKMConf.domains[domain]
  ? window.InbentaKMConf.domains[domain]
  : window.InbentaKMConf.domains.default;


window.InbentaAssetsUrl = typeof sdkConfig.baseUrl !== 'undefined' ? sdkConfig.baseUrl : null;
// If SDK is executed on a non-registered domain, we don't launch it.
if (sdkConfig === undefined) {
  console.error((
    `Domain "${domain} has no authorization to run sdks.` +
    'Please contact Inbenta in order to obtain credentials for this domain.'
  ));
} else {
  app.sdkAuth.inbentaKey = window.InbentaKMConf.inbentaKey;
  // Exclude test page from production statistics
  const isInternalTestPage = (window.location.pathname.indexOf('article/page-de-recherche-test') > -1);
  if (isInternalTestPage) {
    app.sdkConfig.source = 'Debug';
  }

  app.sdkConfig.environment = sdkConfig.environment;

  if (typeof window.InbentaKMConf.secret != 'undefined') {
    app.sdkAuth.secret = window.InbentaKMConf.secret;
    secret = true;
  } else {
    app.sdkAuth.domainKey = sdkConfig.domainKey;
  }
}

switch (sdkConfig.id) {
  default:
    // Customize conf depending of the id
    app.sdkConfig.userType = 0;
    break;
}

// KM and search do not use the same userType
app.sdkConfig.userType = 1;

// Import & build SDK
importScript(`https://sdk.inbenta.io/${app.sdkProduct}/${app.sdkVersion}/inbenta-${app.sdkProduct}-sdk.js`, () => {
  importScript(`https://sdk.inbenta.io/search/${app.sdkVersion}/inbenta-search-sdk.js`, () => {

    // Load sdk using domains
    var sdk = InbentaKmSDK.createFromDomainKey(app.sdkAuth.domainKey, app.sdkAuth.inbentaKey, app.sdkConfig);
    var searchSdk = InbentaSearchSDK.createFromDomainKey(sdkConfig.searchDomainKey, window.InbentaKMConf.inbentaSearchKey, app.sdkConfig);

    let searchBox;
    let searchBoxMobile;
    let searchBoxMain;

    // Init test result page
    initTestResultPage(sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain);

    // Init search boxes
    searchBox = initSearch(sdk, sdkConfig);
    searchBoxMobile = initSearchMobile(sdk, sdkConfig);
    searchBoxMain = initSearchMain(sdk, sdkConfig);

    // Init result page
    initResultPage(sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain);

    // Set-up populars
    initPopular(sdk, sdkConfig);

    // Set-up deflection if needed
    initDeflection(app, InbentaKmSDK, sdkConfig);

    document.querySelector('html').classList.remove('inbenta-km');
  });
});



// WEBPACK FOOTER //
// ./src/scripts/main.js